// extracted by mini-css-extract-plugin
module.exports = {"welcomeElementWrapperMobile":"MobileNotSupportedError_welcomeElementWrapperMobile__22l1z"};